import { Exclude } from "class-transformer";

export const NO = "000000";
export const YES = "000001";
export const NA = "000002";
export const ORGANIC = "000001";
export const CONVENTIONAL = "000000";
export const PARTNERSHIP = "30";
export const PARTNERSHIP_OTHER = "OTHERS";
export const LEAD_SAME_APPL = "LEAD_SAME_APPL";
export const LEAD_DIFF_APPL = "LEAD_DIFF_APPL";
export const CONTACT_SAME_APPL = "000001";
export const CONTACT_SAME_LEAD = "000002";
export const CONTACT_OTHER = "OTHERS";
export const YOUNG_FARMER = "175_1";
export const PROD_INVESTS = "173_4";
export const ROLE_OTHER = "OTHERS";

export type OrganicConventional = typeof ORGANIC | typeof CONVENTIONAL | null;

export interface FormRow {
    rowCode: string;
    valCombo: string | null;
    valCheck: string | null;
    valText: string | null;
    valNum: number | null;
    valDate: string | number | null;
    mandatory: boolean;
    description: string | null;
    tip: string | null;
    limit: number | null;
    type: string;
    expressionLogic: string;
    disabled?: boolean | null;
    isParent: boolean | null;
    parentId?: string | null;
    order: number;
    comboValues: string | number | null;
    styleJson: string | null;

}
export interface Logic {
    id_riga: string;
    type: 'boolean' | 'contain' | 'empty';
    value: string;
    outcome: 'disable' | 'hide' | 'show';
}
export class Form {
    documentId!: number;
    documentCode!: string;
    applicationId!: number;
    pkCuaa!: number;
    rows: { [key: string]: FormRow } = {};
    file_ids: number[] = [];
    upload_urls: string[] = [];
    max_files_upload!: number;

    @Exclude()
    get parsedData(): FormRow[] {
        return Object.values(this.rows);
    }

    @Exclude()
    get parsedUploadDocuments(): { file_ids: number[]; upload_urls: string[]; rows: FormRow[] } {
        return {
            file_ids: this.file_ids,
            upload_urls: this.upload_urls,
            rows: this.parsedData
        };
    }

    @Exclude()
    get isValid(): string[] {
        const errors: string[] = [];
        this.parsedData.forEach(x => {
            x.mandatory &&
                x.valCheck === null &&
                x.valCombo === null &&
                x.valDate === null &&
                x.valNum === null &&
                (!x.valText || x.valText.trim() === "") &&
                errors.push(x.rowCode);
        });
        return errors;
    }
}
